module.exports = __webpack_public_path__ + "img/mawingupost.e914376c.png";